import { Feature } from 'ol';
import VectorSource from 'ol/source/Vector';
import { useMemo } from 'react';
import Polygon from 'ol/geom/Polygon';
import { useSelector } from 'react-redux';
import { mapDataSizeSelector } from '@/redux/map/map.selectors';
import { usePointToProjection } from '@/utils/map/usePointToProjection';

/**
 * Builds the shared {@link VectorSource} holding the white background rectangle
 * that represents the diagram bounds. Map-independent; wrap it with
 * `createCardLayer`.
 */
export const useOlMapCardSource = (): VectorSource<Feature<Polygon>> => {
  const mapSize = useSelector(mapDataSizeSelector);
  const pointToProjection = usePointToProjection();

  const rectangle = useMemo(() => {
    return new Polygon([
      [
        pointToProjection({ x: 0, y: 0 }),
        pointToProjection({ x: mapSize.width, y: 0 }),
        pointToProjection({ x: mapSize.width, y: mapSize.height }),
        pointToProjection({ x: 0, y: mapSize.height }),
        pointToProjection({ x: 0, y: 0 }),
      ],
    ]);
  }, [mapSize.height, mapSize.width, pointToProjection]);

  const rectangleFeature = useMemo(() => {
    return new Feature(rectangle);
  }, [rectangle]);

  return useMemo(() => {
    return new VectorSource({
      features: [rectangleFeature],
    });
  }, [rectangleFeature]);
};
